import React, { useEffect } from 'react'

const WhatsNew = () => {

  useEffect( () => {
    document.title = 'MARELCO Website | What\'s New'
    document.body.removeAttribute( 'hidden' )
  }, [])

  return (
    <>
      <section className='breadcrumb blog_bg'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='breadcrumb_iner'>
                <div className='breadcrumb_iner_item'>
                  <h2>What's New?</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='contact-section area-padding'>
        <div className='container'>
          <div className='text-center mb-3'>
            <button className='btn' type='button' data-toggle='collapse' data-target='public-bidding-2026' aria-expanded='false' aria-controls='collapseBid2026'>
              <h1 className='whats-new-pdf-button-header mb-5 text-center'>2026</h1>
            </button>
          </div>
          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2026008' aria-expanded='false' aria-controls='collapseBid2026'>
              <h6 className='text-heading history-title text-center'>
              Public Bidding for the Supply of Various Electrical Materials for the Reconductoring of Line at Line Segment Brgy. Yook to Brgy. 2, Buenavista, Marinduque
              and Rebidding of Supply, Labor and Materials for the Preventive Maintenance of 5MVA Cagpo Substation
              </h6>
              
            </button>
            <div id='collapseBid2026008'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2026/invitation_to_bid_2026-008.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'> INVITATION PRE-QUALIFY & TO BID</a>
                </div>
                
              </div>
            </div>
          </div>

           <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2026007' aria-expanded='false' aria-controls='collapseBid2026'>
              <h6 className='text-heading history-title text-center'>
              Public Bidding for the Supply of Distribution Line Extension and Housewiring Materials for ER 1-94 Project and 
              Rebidding for the Supply of Smart Meters & Service Vehicles for Technical Service Department (TSD)   
              </h6>
              
            </button>
            <div id='collapseBid2026007'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2026/invitation_to_bid_2026-007.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'> INVITATION PRE-QUALIFY & TO BID</a>
                </div>
                {/* <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2026/bid_bulletin_2026-006-01.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'> BID BULLETIN No. 2026-006-01</a>
                </div>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2026/bid_bulletin_2026-006-02.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'> BID BULLETIN No. 2026-006-02</a>
                </div> */}
              </div>
            </div>
          </div>

           <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2026006' aria-expanded='false' aria-controls='collapseBid2026'>
              <h6 className='text-heading history-title text-center'>
              Public Bidding for the Supply of Materials for the Installation of Insulators and Wire Cover at 5 Feeders &
              Supply of Various Electrical Materials for the Distribution Line Maintenance, Safety Projects and Replacement of kWH Meters &
              Rebidding of Various Electrical Materials for Standard Connection Facilities & Repair and Maintenance
              </h6>
              
            </button>
            <div id='collapseBid2026006'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2026/invitation_to_bid_2026-006.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'> INVITATION PRE-QUALIFY & TO BID</a>
                </div>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2026/bid_bulletin_2026-006-01.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'> BID BULLETIN No. 2026-006-01</a>
                </div>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2026/bid_bulletin_2026-006-02.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'> BID BULLETIN No. 2026-006-02</a>
                </div>
              </div>
            </div>
          </div>

          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2026005' aria-expanded='false' aria-controls='collapseBid2026'>
              <h6 className='text-heading history-title text-center'>
              Public Bidding for the Supply of Service Vehicles for Technical Services Department and Supply of Labor and Materials for the Preventive Maintenance of 5MVA Cagpo Substation 
              </h6>
              
            </button>
            <div id='collapseBid2026005'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2026/invitation_to_bid_2026-005.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'> INVITATION PRE-QUALIFY & TO BID</a>
                </div>
                {/* <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2026/bid_bulletin_2026-004-01.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'> BID BULLETIN No. 2026-004-01</a>
                </div> */}
                
              </div>
            </div>
          </div> 


          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2026004' aria-expanded='false' aria-controls='collapseBid2026'>
              <h6 className='text-heading history-title text-center'>
              Public Bidding for the Supply of Tools and Safety Gadgets
              </h6>
              
            </button>
            <div id='collapseBid2026004'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2026/invitation_to_bid_2026-004.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'> INVITATION PRE-QUALIFY & TO BID</a>
                </div>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2026/bid_bulletin_2026-004-01.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'> BID BULLETIN No. 2026-004-01</a>
                </div>
                
              </div>
            </div>
          </div> 

          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2026003' aria-expanded='false' aria-controls='collapseBid2026'>
              <h6 className='text-heading history-title text-center'>
              Public Bidding for the Supply of Labor and Materials for the Distribution Line Extension of 4 Sitios and 322 Household Connection (ER 1-94) and 
              Supply for Various Electrical Materials for the Standard Connection Facilities & Repair and Maintenance
              </h6>
              
            </button>
            <div id='collapseBid2026003'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2026/invitation_to_bid_2026-003.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'> INVITATION PRE-QUALIFY & TO BID</a>
                </div>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2026/bid_bulletin_2026-003-01.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'> BID BULLETIN No. 2026-003-01</a>
                </div>
                 <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2026/RFQ_2026-003-01.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'> REQUEST FOR QUOTATION (RFQ)</a>
                </div>
              </div>
            </div>
          </div> 

          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2026002' aria-expanded='false' aria-controls='collapseBid2026'>
              <h6 className='text-heading history-title text-center'>
               Public Bidding for the Supply of Labor and Materials for the Distribution Line Extension of 4 Sitios and 322 Household Connection (ER 1-94)
              </h6>
              
            </button>
            <div id='collapseBid2026002'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2026/invitation_to_bid_2026-002.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'> INVITATION TO PRE-QUALIFY & TO BID </a>
                </div>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2026/RFQ_2026-003-01.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'> REQUEST FOR QUOTATION (RFQ)</a>
                </div>
              </div>
            </div>
          </div> 

          

          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2026001-2' aria-expanded='false' aria-controls='collapseBid2026'>
              <h6 className='text-heading history-title text-center'>
              Procurement of a Parcel of Land for the Proposed 10MVA Substation at Sta. Cruz, Marinduque
              </h6>
              
            </button>
            <div id='collapseBid2026001-2'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2026/procurement_of_land_10mva.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'> INVITATION TO BID</a>
                </div>
                
              </div>
            </div>
          </div> 

          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2026001' aria-expanded='false' aria-controls='collapseBid2026'>
              <h6 className='text-heading history-title text-center'>
              Negotiated Procurement - Supply, Delivery, and Installation of Various Materials for the Construction of Line Extension and Housewiring Installation
              funded thru the Department of Energy - Total Electrification Program (DOE-TEP) 2025
              </h6>
              
            </button>
            <div id='collapseBid2026001'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2026/RFQ_2026-010-001.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'> RFQ 2026-010</a>
                </div>
              </div>
              </div>
          </div>
          
          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2026001-1' aria-expanded='false' aria-controls='collapseBid2026'>
              <h6 className='text-heading history-title text-center'>
              Public Bidding for the Supply, Delivery, and Installation of Various Materials for Construction of Line Extension and Housewiring Installation 
              funded thru Department of Energy - Total  Electrification Program (DOE-TEP)
              </h6>
              
            </button>
            <div id='collapseBid2026001-1'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2026/invitation_to_bid_2026-001.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'> INVITATION TO PRE-QUALIFY & TO BID</a>
                </div>
                
              </div>
            </div>
          </div> 

        </div>
      </section>
      <hr />

      <section className='contact-section area-padding'>
        <div className='container'>
          <div className='text-center mb-3'>
            <button className='btn' type='button' data-toggle='collapse' data-target='public-bidding-2024' aria-expanded='false' aria-controls='collapseBid2025'>
              <h1 className='whats-new-pdf-button-header mb-5 text-center'>2025</h1>
            </button>
          </div>

          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2025010' aria-expanded='false' aria-controls='collapseBid2025'>
              <h6 className='text-heading history-title text-center'>
              Public Bidding for the Engagement/Provision of Security Service for MARELCO (3 years Contract)
              </h6>
              
            </button>
            <div id='collapseBid2025010'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/invitation_to_bid_2025-0010.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                </div>

              </div>
            </div>
          </div> 

          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2025009' aria-expanded='false' aria-controls='collapseBid2025'>
              <h6 className='text-heading history-title text-center'>
              Public Bidding for the Engagement/Provision of Security Service for MARELCO (3 years Contract)
              </h6>
              
            </button>
            <div id='collapseBid2025009'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/invitation_to_bid_2025-009.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                </div>

                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/Bid_Bulletin_2025-009-01.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>BID BULLETIN No. 2025-009-01</a>
                </div> 

              </div>
            </div>
          </div> 

          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2025008' aria-expanded='false' aria-controls='collapseBid2025'>
              <h6 className='text-heading history-title text-center'>
              Public Bidding for the Supply of Meter Test Equipment (Meter Test Bench 6 Position)
              </h6>
              
            </button>
            <div id='collapseBid2025008'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/invitation_to_bid_2025-008.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                </div>

                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/Bid_Bulletin_2025-008-01.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>BID BULLETIN No. 2025-008-01</a>
                </div> 

                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/Annex_C_2025-008.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>Annex C</a>
                </div> 

              </div>
            </div>
          </div> 

          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2025007' aria-expanded='false' aria-controls='collapseBid2025'>
              <h6 className='text-heading history-title text-center'>
              Public Bidding for the Supply of Labor and Various Materials for the Construction of Line Extension and House Wiring Installation funded thru the Department of Energy - Total Electrification Program (DOE-TEP)
              </h6>
              
            </button>
            <div id='collapseBid2025007'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/invitation_to_bid_2025-007.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                </div>
                           
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/instruction_to_bidders_2025-007.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INSTRUCTION TO BIDDERS</a>
                </div>

                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/Bid_Bulletin_2025-007-01.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>BID BULLETIN No. 2025-007-01</a>
                </div> 

                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/Bid_Bulletin_2025-007-02.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>BID BULLETIN No. 2025-007-02</a>
                </div> 

                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/Bid_Evaluation_Tool.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>Bid Evaluation Tool</a>
                </div> 

                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/Checklist_of_Requirements.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>Checklist of Requirements</a>
                </div> 

              </div>
            </div>
          </div> 

          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2025006' aria-expanded='false' aria-controls='collapseBid2025'>
              <h6 className='text-heading history-title text-center'>
              Public Bidding for the Supply of Materials for the Installation of Insulators and Wire Covers
              </h6>
              
            </button>
            <div id='collapseBid2025006'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/invitation_to_pre-qualify_&_to_bid_2025-006.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                </div>
                           
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/list_of_materials_2025-006.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>LIST OF MATERIALS</a>
                </div>

              </div>
            </div>
          </div> 

          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2025005' aria-expanded='false' aria-controls='collapseBid2025'>
              <h6 className='text-heading history-title text-center'>
              Public Bidding for the Supply of Various Electrical Materials for the Relocation of Poles and Line Affected by DPWH Road Widening under JC1 Batch 8 and For New Connection, Temporary Connection and Change Meter
              </h6>
              
            </button>
            <div id='collapseBid2025005'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/invitation_to_pre-qualify_&_to_bid_2025-005.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                </div>
                           
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/list_of_materials_2025-005.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>LIST OF MATERIALS</a>
                </div>

                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/Bid_Bulletin_2025-005-01.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>BID BULLETIN No. 2025-005-01 </a>
                </div> 
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/Bid_Bulletin_2025-005-02.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>BID BULLETIN No. 2025-005-02 </a>
                </div> 
              </div>
            </div>
          </div> 

          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2025004' aria-expanded='false' aria-controls='collapseBid2025'>
              <h6 className='text-heading history-title text-center'>
              Public Bidding for the Supply of Operation and Maintenance Tools & Safety Tools and Gadgets and Supply of Labor & Materials for Pole Tagging
              </h6>
              
            </button>
            <div id='collapseBid2025004'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/invitation_to_pre-qualify_&_to_bid_2025-004.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                </div>
              </div>
            </div>
          </div> 

          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2025003' aria-expanded='false' aria-controls='collapseBid2025'>
              <h6 className='text-heading history-title text-center'>
              Public Bidding for the Supply of Various Electrical Materials, Tools and Gadgets for Various CAPEX Projects
              </h6>
              
            </button>
            <div id='collapseBid2025003'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/invitation_to_pre-qualify_&_to_bid_2025-003.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                </div>
                           
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/list_of_materials_2025-003.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>LIST OF MATERIALS</a>
                </div>
              </div>
            </div>
          </div> 

          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2025002' aria-expanded='false' aria-controls='collapseBid2025'>
              <h6 className='text-heading history-title text-center'>
              Public Bidding for Replenishment of Materials/Hardwares used in Special Projects
              </h6>
              
            </button>
            <div id='collapseBid2025002'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/invitation_to_pre-qualify_&_to_bid_2025-002.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                </div>
                           
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/list_of_materials_2025-002.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>LIST OF MATERIALS</a>
                </div>
              </div>
            </div>
          </div> 

          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2025001' aria-expanded='false' aria-controls='collapseBid2025'>
              <h6 className='text-heading history-title text-center'>
               Public Bidding for Supply of Labor and Materials for the Construction of Buenavista Area Office (One-Storey Office Building) at Brgy. I, Buenavista, Marinduque
              </h6>
              
            </button>
            <div id='collapseBid2025001'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/2025/invitation_to_pre-qualify_&_to_bid_2025-001.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                </div>
              </div>
            </div>
          </div> 

      
        </div>
      </section>
      <hr />

      <section className='contact-section area-padding'>
        <div className='container'>
          <div className='text-center mb-3'>
            <button className='btn' type='button' data-toggle='collapse' data-target='public-bidding-2024' aria-expanded='false' aria-controls='collapseBid2024'>
              <h1 className='whats-new-pdf-button-header mb-5 text-center'>2024</h1>
            </button>
          </div>

          <div id='collapseBid2024' className='collapse hide'>
            <div className='public-bidding'>
              <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2024008' aria-expanded='false' aria-controls='collapseBid2024'>
                <h6 className='text-heading history-title text-center'>
                Public Bidding for the Engagement/Provision of Security Services for MARELCO <br /><small> (January 16, 2025 to January 15, 2026)</small>
                </h6>
                
              </button>
              <div id='collapseBid2024008'>
                <div className='text-center mb-5'>

                  <div className='whats-new-pdf-button-container'>
                    <a href='/resources/files/whats_new/invitation_to_pre-qualify_&_to_bid_2024-007.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                  </div>
                </div>

              </div>
            </div> 


            <div className='public-bidding'>
              <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2024007' aria-expanded='false' aria-controls='collapseBid2024'>
                <h6 className='text-heading history-title text-center'>
                Public Bidding for the Engagement/Provision of Security Services for MARELCO <br /><small> (January 16, 2025 to January 15, 2026)</small>
                </h6>
                
              </button>
              <div id='collapseBid2024007'>
                <div className='text-center mb-5'>

                  <div className='whats-new-pdf-button-container'>
                    <a href='/resources/files/whats_new/invitation_to_pre-qualify_&_to_bid_2024-006.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                  </div>

                  <div className='whats-new-pdf-button-container'>
                    <a href='/resources/files/whats_new/Bid_Bulletin_2024-006-01.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>BID BULLETIN No. 2024-006-01 </a>
                  </div> 
                </div>

              </div>
            </div> 

            <div className='public-bidding'>
              <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2024006' aria-expanded='false' aria-controls='collapseBid2024'>
                <h6 className='text-heading history-title text-center'>
                Public Bidding for the Supply of Various Electrical Materials for the Relocation of Poles and Lines affected by DPWH Road Widening
                under JC 1 Batch 7 & Replenishment of Materials/Hardwares used in Special Projects 
                </h6>
              </button>
              <div id='collapseBid2024006'>
                <div className='text-center mb-5'>

                  <div className='whats-new-pdf-button-container'>
                    <a href='/resources/files/whats_new/invitation_to_pre-qualify_&_to_bid_2024-005.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                  </div> 
              
                  <div className='whats-new-pdf-button-container'>
                    <a href='/resources/files/whats_new/list_of_materials_2024-005.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>LIST OF MATERIALS</a>
                  </div> 

                  <div className='whats-new-pdf-button-container'>
                    <a href='/resources/files/whats_new/Bid_Bulletin_2024-005-01.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>BID BULLETIN No. 2024-005-01 </a>
                  </div>  <br /><br />
                  
                  <div className='whats-new-pdf-button-container'>
                    <a href='/resources/files/whats_new/Bid_Bulletin_2024-005-02.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>BID BULLETIN No. 2024-005-02 </a>
                  </div>
                  
                </div>

              </div>
            </div> 

            <div className='public-bidding'>
              <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2024004' aria-expanded='false' aria-controls='collapseBid2024'>
                <h6 className='text-heading history-title text-center'>
                Public Bidding for the Supply of Various Electrical Materials for the Relocation of Poles and Lines affected by DPWH Road Widening
                under JC 1 Batch 7 & Replenishment of Materials/Hardwares used in Special Projects 
                </h6>
              </button>
              <div id='collapseBid2024005'>
                <div className='text-center mb-5'>

                  <div className='whats-new-pdf-button-container'>
                    <a href='/resources/files/whats_new/invitation_to_pre-qualify_&_to_bid_2024-004.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                  </div>
              
                  <div className='whats-new-pdf-button-container'>
                    <a href='/resources/files/whats_new/list_of_materials_2024-004.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>LIST OF MATERIALS</a>
                  </div>

                  
                </div>

              </div>
            </div>                                                                                                    

            <div className='public-bidding'>
              <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2024004' aria-expanded='false' aria-controls='collapseBid2024'>
                <h6 className='text-heading history-title text-center'>
                Public Bidding for the Supply of Various Electrical Materials for the Upgrading and Rehabilitation of Lines from Bare to Tree Wire at Portion of Feeder 4 
                </h6>
              </button>
              <div id='collapseBid2024004'>
                <div className='text-center mb-5'>

                  <div className='whats-new-pdf-button-container'>
                    <a href='/resources/files/whats_new/invitation_to_pre-qualify_&_to_bid_2024-003.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                  </div>
              
                  <div className='whats-new-pdf-button-container'>
                    <a href='/resources/files/whats_new/list_of_materials_2024-003.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>LIST OF MATERIALS</a>
                  </div>

                  <div className='whats-new-pdf-button-container'>
                    <a href='/resources/files/whats_new/Bid_Bulletin_2024-003-01.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>BID BULLETIN No. 2024-003-01 </a>
                  </div>


                </div>

              </div>
            </div>    

            <div className='public-bidding'>
              <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2024003' aria-expanded='false' aria-controls='collapseBid2024'>
                <h6 className='text-heading history-title text-center'>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  Procurement of Lot in Buenavista   
                </h6>
              </button>
              <div id='collapseBid2024003'>
                <div className='text-center mb-5'>

                  <div className='whats-new-pdf-button-container'>
                    <a href='/resources/files/whats_new/Invitation&RFQ2024-018.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION & REQUEST FOR QUOTATION</a>
                  </div>
                </div>
              </div>
            </div>    

            <div className='public-bidding'>
              <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2024002' aria-expanded='false' aria-controls='collapseBid2024'>
                <h6 className='text-heading history-title'>
                Public Bidding for the Supply of Various Electrical Materials for Coop Use  
                </h6>
              </button>
              <div id='collapseBid2024002'>
                <div className='text-center mb-5'>
                  <div className='whats-new-pdf-button-container'>
                    <a href='/resources/files/whats_new/invitation_to_pre-qualify_&_to_bid_2024-002.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                  </div>
                  <div className='whats-new-pdf-button-container'>
                    <a href='/resources/files/whats_new/list_of_materials_2024-002.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>LIST OF MATERIALS</a>
                  </div>
                </div>
              </div>
            </div>       

            <div className='public-bidding'>
              <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2024001' aria-expanded='false' aria-controls='collapseBid2024'>
                <h6 className='text-heading history-title'>
                Public Bidding for the Supply of Two (2) Units of Boom Truck for Coop Use  
                </h6>
              </button>
              <div id='collapseBid2024001'>
                <div className='text-center mb-5'>
                  <div className='whats-new-pdf-button-container'>
                    <a href='/resources/files/whats_new/invitation_to_pre-qualify_&_to_bid_2024-001.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                  </div>
                  <div className='whats-new-pdf-button-container'>
                    <a href='/resources/files/whats_new/specifications_2024-001.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>BOOM TRUCK SPECIFICATIONS</a>
                  </div>
                  <div className='whats-new-pdf-button-container'>
                    <a href='/resources/files/whats_new/Bid Bulletin No. 2024-001-01.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>BID BULLETIN No. 2024-001-01 </a>
                  </div>
                </div>
              </div>
            </div>
          </div>  
        </div>
      </section>
      <hr />


      <section className='contact-section area-padding'>
        <div className='container'>
          <div className='text-center mb-3'>
            <button className='btn' type='button' data-toggle='collapse' data-target='#collapseBid2023' aria-expanded='false' aria-controls='collapseBid2023'>
              <h1 className='whats-new-pdf-button-header mb-5 text-center'>2023</h1>
            </button>
          </div>
          
        <div id='collapseBid2023' className='collapse hide'>
          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2023008' aria-expanded='false' aria-controls='collapseBid2023'>
              <h6 className='text-heading history-title'>
              Public Bidding for the Supply of Various Electrical Materials for 2023 Sitio Electrification Program (SEP)  
              </h6>
            </button>
            <div id='collapseBid2023008' className='collapse show'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/invitation_to_pre-qualify_&_to_bid_2023-008.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                </div>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/list_of_materials_2023-008.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>LIST OF MATERIALS</a>
                </div>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/Bid_Bulletin_2023-008-01.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>BID BULLETIN No. 2023-008-01 </a>
                </div>
              </div>
            </div>
          </div>

          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2023007' aria-expanded='false' aria-controls='collapseBid2023'>
              <h6 className='text-heading history-title'>
              Public Bidding for the Supply of Various Electrical Materials for Replenishment of Materials Used for Special Projects  
              </h6>
            </button>
            <div id='collapseBid2023007'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/invitation_to_pre-qualify_&_to_bid_2023-007.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                </div>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/list_of_materials_2023-007.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>LIST OF MATERIALS</a>
                </div>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/Bid_Bulletin_2023-007-01.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>BID BULLETIN No. 2023-007-01 </a>
                </div>
              </div>
            </div>
          </div>

          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2023006' aria-expanded='false' aria-controls='collapseBid2023'>
              <h6 className='text-heading history-title'>
                Public Bidding for the Supply of Various Electrical Materials for Relocation of Poles affected by DPWH Projects  
              </h6>
            </button>
            <div id='collapseBid2023006'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/invitation_to_pre-qualify_&_to_bid_2023-006.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                </div>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/list_of_materials_2023-006.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>LIST OF MATERIALS</a>
                </div>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/Bid_Bulletin_2023-006-01.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>BID BULLETIN No. 2023-006-01 </a>
                </div>

              </div>
            </div>
          </div>


          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2023005' aria-expanded='false' aria-controls='collapseBid2023'>
              <h6 className='text-heading history-title'>
              Public Bidding for the Supply of Various Materials for the Rehabilitation of Vee Phase Line, Transformer and Metering Installation at Globe, Lupac, Boac & Other Special Projects              
              </h6>
            </button>
            <div id='collapseBid2023005'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/invitation_to_pre-qualify_&_to_bid_2023-005.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                </div>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/list_of_materials_2023-005.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>LIST OF MATERIALS</a>
                </div>
              </div>
            </div>
          </div>
          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2023004' aria-expanded='false' aria-controls='collapseBid2023'>
              <h3 className='text-heading history-title'>
              Public Bidding for the Supply of Labor and Materials for the Construction of Line Extension and Housewiring Installation for 2023 Sitio Electrification Program (SEP)
              </h3>
            </button>
            <div id='collapseBid2023004'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/invitation_to_pre-qualify_&_to_bid_2023-004.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                </div>
             </div>
            </div>
          </div>
          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2023003' aria-expanded='false' aria-controls='collapseBid2023'>
              <h3 className='text-heading history-title'>
                Public Bidding for the Supply of Various Electrical Materials for Coop Operation and Maintenance and 2023 Sitio Electrification Program (SEP)
              </h3>
            </button>
            <div id='collapseBid2023003'>
              <div className='text-center mb-5'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/invitation_to_pre-qualify_&_to_bid_2023-003.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                </div>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/list_of_materials_2023-003.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>LIST OF MATERIALS</a>
                </div>
              </div>
            </div>
          </div>
          <div className='public-bidding'>
            <button className='btn' type='button' data-toogle='collapse' data-target='#collapseBid2023002' aria-expanded='false' aria-controls='collapseBid2023'>
              <h3 className='text-heading history-title'>
                Public Bidding for the Supply of Line Hardwares and Miscellaneous Materials for Relocation of Poles affected by DPWH Projects (JC1 Batch 6) & Replenishment of Various Electrical Materials Used for the Repair and Rehabilitation of Distribution Lines damaged by Typhoon Paeng
              </h3>
            </button>
            <div id='collapseBid2023002'>
              <div className='text-center'>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/invitation_to_pre-qualify_&_to_bid_2023-002.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
                </div>
                <div className='whats-new-pdf-button-container'>
                  <a href='/resources/files/whats_new/list_of_materials_2023-002.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>LIST OF MATERIALS</a>
                </div>
              </div>
            </div>
          </div>

          <button className='btn' type='button' data-toggle='collapse' data-target='#collapseBid2023001' aria-expanded='false' aria-controls='collapseBid2023'>
            <h3 className='text-heading history-title'>
              Public Bidding for Supply of Various Electrical Materials for Relocation of Poles affected by DPWH Projects
            </h3>
          </button>  
          <div id='collapseBid2023001'>
            <div className='text-center'>
              <div className='whats-new-pdf-button-container'>
                <a href='/resources/files/whats_new/invitation_to_bid_2023-001.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>INVITATION TO PRE-QUALIFY & TO BID</a>
              </div>
              <div className='whats-new-pdf-button-container'>
                <a href='/resources/files/whats_new/list_of_materials_2023-001.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '5px 5px', fontSize: 14}} className='genric-btn info'>LIST OF MATERIALS</a>
              </div>
            </div>
          </div>
        </div>
        </div>
      </section>
      <hr />

      <section className='contact-section area-padding'>
        <div className='container'>
          <div className='text-center'>
            <button className='btn' type='button' data-toggle='collapse' data-target='#collapseBid2022'  aria-expanded='false' aria-controls='collapseBid2022'>
              <h1 className='whats-new-pdf-button-header mb-3 text-center'>2022</h1>
            </button>
          </div>
          <div id='collapseBid2022' className='collapse hide' >
            <h3 className='text-heading history-title'>
                BID BULLETIN<br />
              <small>(2022)</small>
            </h3>
            <div className='text-center'>
              <div>
                <div className='whats-new-pdf-button-container'>
                  <div className='whats-new-pdf-button-header'>NO. 2022-001-01</div>
                  <a href='/resources/files/whats_new/Bid Bulletin No. 2022-001-01.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
                </div>
                <div className='whats-new-pdf-button-container'>
                  <div className='whats-new-pdf-button-header'>NO. 2022-001-02</div>
                  <a href='/resources/files/whats_new/Bid Bulletin No. 2022-001-02.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
                </div>
                <div className='whats-new-pdf-button-container'>
                  <div className='whats-new-pdf-button-header'>NO. 2022-002-01</div>
                  <a href='/resources/files/whats_new/Bid Bulletin No. 2022-002-01.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
                </div>
              </div>
              <div className='mt-5'>
                <div className='whats-new-pdf-button-container'>
                  <div className='whats-new-pdf-button-header'>NO. 2022-004-01</div>
                  <a href='/resources/files/whats_new/Bid Bulletin No. 2022-004-01.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
                </div>
                <div className='whats-new-pdf-button-container-split'>
                  <div className='whats-new-pdf-button-header'>NO. 2022-004-02</div>
                  <a href='/resources/files/whats_new/Bid Bulletin No. 2022-004-02.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
                  <div className='genric-btn info dropdown-btn' data-toggle='dropdown'><span className='fas fa-caret-down'></span></div>
                  <div className='dropdown-menu' role='menu'>
                    <span className='dropdown-label'>Attachments</span>
                <div className='dropdown-divider' />
                  <a className='dropdown-item' href='/resources/files/whats_new/Bid Bulletin No. 2022-004-02 - Attachment 1.docx' target='_blank' rel='noopener noreferrer'>1. Omnibus Sworn Statemen (docx)</a>
                  <a className='dropdown-item' href='/resources/files/whats_new/Bid Bulletin No. 2022-004-02 - Attachment 2.pdf' target='_blank' rel='noopener noreferrer'>2. Sample Proof of VAT Payments... (pdf)</a>
                  <a className='dropdown-item' href='/resources/files/whats_new/Bid Bulletin No. 2022-004-02 - Attachment 3.pdf' target='_blank' rel='noopener noreferrer'>3. Sample Tax Clearance Certificate (pdf)</a>
                  <a className='dropdown-item' href='/resources/files/whats_new/Bid Bulletin No. 2022-004-02 - Attachment 4.pdf' target='_blank' rel='noopener noreferrer'>4. Authority of Signatory (pdf)</a>
                  <a className='dropdown-item' href='/resources/files/whats_new/Bid Bulletin No. 2022-004-02 - Attachment 5.docx' target='_blank' rel='noopener noreferrer'>5. Notarized Statement on Warranty... (docx)</a>
                  <a className='dropdown-item' href='/resources/files/whats_new/Bid Bulletin No. 2022-004-02 - Attachment 6.xlsx' target='_blank' rel='noopener noreferrer'>6. Notarized Statement on Completion (xlsx)</a>
                  <a className='dropdown-item' href='/resources/files/whats_new/Bid Bulletin No. 2022-004-02 - Attachment 7.xlsx' target='_blank' rel='noopener noreferrer'>7. Detailed Technical Specifications (xlsx)</a>
                </div>
              </div>
              <div className='whats-new-pdf-button-container'>
                <div className='whats-new-pdf-button-header'>NO. 2022-004-03</div>
                <a href='/resources/files/whats_new/Bid Bulletin No. 2022-004-03.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
              </div>
            </div>
          </div>
          <br/><br/><br/><br/>

          <h3 className='text-heading history-title'>
            PUBLIC BIDDING 2022-004<br />
            <small>Proposed Building Design for the Two-Storey Office Building at Brgy. Maharlika-Poblacion, Sta. Cruz, Marinduque</small><br />
            <small>(2022)</small>
          </h3>
          <div className='text-center'>
            <div className='whats-new-pdf-button-container'>
              <a href='/resources/files/whats_new/public_bidding_proposed_building_design.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
            </div>
          </div>
          <br/><br/><br/><br/>
       
          <h3 className='text-heading history-title'>
            PROCUREMENT OF CLOSED CIRCUIT TELEVISION (CCTV) SYSTEM<br />
            <small>for MARELCO Establishments</small><br />
            <small>(2022)</small>
          </h3>
          <div className='text-center'>
            <div className='whats-new-pdf-button-container'>
              <a href='/resources/files/whats_new/procurement_2022_001.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
            </div>
          </div>
          <br/><br/><br/><br/>
      
          <h3 className='text-heading history-title'>
            INVITATION TO PRE-QUALIFY AND TO BID<br />
            <small>for the Supply of Labor and Materials for the Construction of Two-Storey Office Building at Brgy. Maharlika-Poblacion, Sta. Cruz, Marinduque</small><br />
            <small>(2022)</small>
          </h3>
          <div className='text-center'>
            <div className='whats-new-pdf-button-container'>
              <a href='/resources/files/whats_new/invitation_to_bid_2022-004.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
            </div>
          </div>
          <br/><br/><br/><br/>
      
          <h3 className='text-heading history-title'>
            INSTRUCTION TO BIDDERS<br />
            <small>Supply of Labor and Materials for the Construction of Two-Storey Office Building at Brgy. Maharlika-Poblacion, Sta. Cruz, Marinduque</small><br />
            <small>(2022)</small>
          </h3>
          <div className='text-center'>
            <div className='whats-new-pdf-button-container'>
              <a href='/resources/files/whats_new/instruction_to_bidders_2022-004.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
            </div>
          </div>
          <br/><br/><br/><br/>
       
          <h3 className='text-heading history-title'>
            INVITATION TO PRE-QUALIFY AND TO BID<br />
            <small>for the Supply of Minivan and Pickup Truck Service for Coop Use</small><br />
            <small>(2022)</small>
          </h3>
          <div className='text-center'>
            <div className='whats-new-pdf-button-container'>
              <a href='/resources/files/whats_new/invitation_to_bid_2022-003.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
            </div>
          </div>
          <br/><br/><br/><br/>
       
          <h3 className='text-heading history-title'>
            INSTRUCTION TO BIDDERS<br />
            <small>Supply of Various Electrical Materials for relocation of poles affected by the DPWH Project, DOE-DPWH Joint Circular 1 (JC1) Batch 5, and Supply of Book Truck and Other Service Vehicles for Coop Use</small><br />
            <small>(2022)</small>
          </h3>
          <div className='text-center'>
            <div className='whats-new-pdf-button-container'>
              <a href='/resources/files/whats_new/instruction_to_bidders_2022-002.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
            </div>
          </div>
          <br/><br/><br/><br/>
       
          <h3 className='text-heading history-title'>
            List of Materials for Public Bidding<br />
            <small>JC 1 Batch 5</small><br />
            <small>(2022)</small>
          </h3>
          <div className='text-center'>
            <div className='whats-new-pdf-button-container'>
              <a href='/resources/files/whats_new/public_bidding_list_of_materials_2022-002.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
            </div>
          </div>
          <br/><br/><br/><br/>
       
          <h3 className='text-heading history-title'>
            INVITATION TO PRE-QUALIFY AND TO BID<br />
            <small>for the Supply of Various Electrical Materials for the Relocation of Poles affected by DPWH Project (JC1 Batch 5) and Supply of Boom Truck &amp; Other Service Vehicles for Coop Use</small><br />
            <small>(2022)</small>
          </h3>
          <div className='text-center'>
            <div className='whats-new-pdf-button-container'>
              <a href='/resources/files/whats_new/invitation_to_bid_2022-002.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
            </div>
          </div>
          <br/><br/><br/><br/>
     
          <h3 className='text-heading history-title'>
            REVISED INSTRUCTION TO BIDDERS<br />
            <small>Supply of Various Electrical Materials for Coop Operation and Maintenance and Sitio Electrification Program (SEP) 2021</small><br />
            <small>(2022)</small>
          </h3>
          <div className='text-center'>
            <div className='whats-new-pdf-button-container'>
              <a href='/resources/files/whats_new/instruction_to_bidders_2022-001.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
            </div>
          </div>
          <br/><br/><br/><br/>
     
          <h3 className='text-heading history-title'>
            INSTRUCTION TO BIDDERS<br />
            <small>Supply of Various Electrical Materials for Coop Operation and Maintenance and Sitio Electrification Program (SEP)</small><br />
            <small>(2022)</small>
          </h3>
          <div className='text-center'>
            <div className='whats-new-pdf-button-container'>
              <a href='/resources/files/whats_new/instruction_to_bidders_3.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
            </div>
          </div>
          <br/><br/><br/><br/>
     
          <h3 className='text-heading history-title'>
            List of Materials for Public Bidding<br />
            <small>Note: Discrepancy on total ABC versus the amount stated on the advertisement is due to the changes in the quantity and unit cost of some materials.</small><br />
            <small>(2022)</small>
          </h3>
          <div className='text-center'>
            <div className='whats-new-pdf-button-container'>
              <a href='/resources/files/whats_new/public_bidding_list_of_materials_5.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
            </div>
          </div>
         </div>
        </div>
      </section>
      <hr />
      <section className='contact-section area-padding'>
        <div className='container'>
          <div className='text-center'>
            <button className='btn' type='button' data-toggle='collapse' data-target='#collapseBid2021' aria-expanded='false' aria-controls='collapseBid2019'>
              <h1 className='whats-new-pdf-button-header mb-3 text-center'>2021</h1>
            </button>
          </div>
          <div id='collapseBid2021' className='collapse hide'>
          <h3 className='text-heading history-title'>
            BID BULLETIN<br />
            <small>(2021)</small>
          </h3>
          <div className='text-center'>
            <div className='whats-new-pdf-button-container'>
              <div className='whats-new-pdf-button-header'>NO. 2021-004-001</div>
              <a href='/resources/files/whats_new/Bid Bulletin No. 2021-004-001.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
            </div>
          </div>
          <br /><br /><br/>
     
          <h3 className='text-heading history-title'>
            List of Materials for Public Bidding<br />
            <small>for the Supply of Various Electrical Materials for Relocation of Poles affected by DPWH Projects and Other Special Projects</small><br />
            <small>(2021)</small>
          </h3>
          <div className='text-center'>
            <div className='whats-new-pdf-button-container'>
              <a href='/resources/files/whats_new/public_bidding_list_of_materials_4.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
            </div>
          </div>
          <br /><br /><br/>
  
          <h3 className='text-heading history-title'>
            INSTRUCTION TO BIDDERS<br />
            <small>Supply of Various Electrical Materials for the Relocation of Pole affected by DPWH Projects (JC2) and Other Special Projects</small><br />
            <small>(2021)</small>
          </h3>
          <div className='text-center'>
            <div className='whats-new-pdf-button-container'>
              <a href='/resources/files/whats_new/instruction_to_bidders_2.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
            </div>
          </div>
          <br /><br /><br/>
     
          <h3 className='text-heading history-title'>
            INVITATION TO PRE-QUALIFY AND TO BID<br />
            <small>for Relocation of Poles affected by DPWH Projects</small><br />
            <small>(2021)</small>
          </h3>
          <div className='text-center'>
            <div className='whats-new-pdf-button-container'>
              <a href='/resources/files/whats_new/invitation_to_bid_5.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
            </div>
          </div>
          <br /><br /><br/>
     
          <h3 className='text-heading history-title'>
            List of Materials for Public Bidding<br />
            <small>for the Relocation of Poles affected by DPWH Projects</small><br />
            <small>(2021)</small>
          </h3>
          <div className='text-center'>
            <div className='whats-new-pdf-button-container'>
              <a href='/resources/files/whats_new/public_bidding_list_of_materials_3.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
            </div>
          </div>
          <br /><br /><br/>
     
      <h3 className='text-heading history-title'>
        2nd INVITATION TO PRE-QUALIFY AND TO BID<br />
        <small>(2021)</small>
      </h3>
      <div className='text-center'>
        <div className='whats-new-pdf-button-container'>
          <a href='/resources/files/whats_new/invitation_to_bid_4.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
        </div>
      </div>
      <br /><br /><br/>
    
          <h3 className='text-heading history-title'>
            List of Materials for Public Bidding<br />
            <small>(BAC 2021-003)</small>
          </h3>
          <div className='text-center'>
            <div className='whats-new-pdf-button-container'>
              <a href='https://drive.google.com/drive/folders/1tR_MhyCYEZaETrZl41Po2CvTeeY7hBX-?usp=sharing' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>Google Drive Link</a>
            </div>
          </div>
          <br /><br /><br/>
     
          <h3 className='text-heading history-title'>
            INVITATION TO PRE-QUALIFY AND TO BID<br />
            <small>(2021)</small>
          </h3>
          <div className='text-center'>
            <div className='whats-new-pdf-button-container'>
              <a href='/resources/files/whats_new/invitation_to_bid_3.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
            </div>
          </div>
          <br /><br /><br/>
    
          <h3 className='text-heading history-title'>
            List of Materials for Public Bidding<br />
            <small>(2021)</small>
          </h3>
          <div className='text-center'>
            <div className='whats-new-pdf-button-container'>
              <a href='/resources/files/whats_new/public_bidding_list_of_materials_2.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
            </div>
          </div>
          <br /><br /><br/>
       
          <h3 className='text-heading history-title'>
            INVITATION TO PRE-QUALIFY AND TO BID<br />
            <small>(2021)</small>
          </h3>
          <div className='text-center'>
            <div className='whats-new-pdf-button-container'>
              <a href='/resources/files/whats_new/invitation_to_bid_2.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
            </div>
          </div>
          <br /><br /><br/>
   
          <h3 className='text-heading history-title'>
            BID BULLETIN<br />
            <small>(2021)</small>
          </h3>
          <div className='text-center'>
            <div className='whats-new-pdf-button-container'>
              <div className='whats-new-pdf-button-header'>NO. 2021-002</div>
              <a href='/resources/files/whats_new/Bid Bulletin No. 2021-002.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
            </div>
          </div>
          <br /><br /><br/>
    
          <h3 className='text-heading history-title'>
            List of Materials for Public Bidding<br />
            <small>(2021)</small>
          </h3>
          <div className='text-center'>
            <div className='whats-new-pdf-button-container'>
              <a href='/resources/files/whats_new/public_bidding_list_of_materials.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
            </div>
          </div>
          </div>
        </div>
      </section>
      <hr />
      <section className='contact-section area-padding'>
        <div className='container'>
          <div className='text-center'>
            <button className='btn' type='button' data-toggle='collapse' data-target='#collapseBid2020'  aria-expanded='false' aria-controls='collapseBid2020'>
              <h1 className='whats-new-pdf-button-header mb-3 text-center'>2020</h1>
            </button>
          </div>
          <div id='collapseBid2020' className='collapse hide'>
            <h3 className='text-heading history-title'>
              COMPETITIVE SELECTION PROCESS (CSP) UPDATES<br />
              <small>(2020)</small>
              <br /><br />
              <small>
                The Marinduque Electric Cooperative, Inc. (MARELCO) informs its stakeholders and
                member-consumer-owners of the following Generation Companies who express their
                intent to participate on MARELCO’s Competitive Selection Process (CSP) for its New
                Power Provider (NPP), to wit:
              </small>
              <br /><br />
              <table style={{width: '100%', fontSize: 30, textAlign: 'center'}}>
                <tbody><tr>
                    <td>YH Green Energy Inc.</td>
                  </tr>
                  <tr>
                    <td>DMCI Power Corporation</td>
                  </tr>
                  <tr>
                    <td>Energreen Power Inter-Island Corporation</td>
                  </tr>
                  <tr>
                    <td>Solar Philippines Power Project Holdings</td>
                  </tr>
                  <tr>
                    <td>Occ. Mindoro Consolidated Power Corp.</td>
                  </tr>
                  <tr>
                    <td>Mindoro Grid Corporation</td>
                  </tr>
                  <tr>
                    <td>Sunwest Corporation</td>
                  </tr>
                  <tr>
                    <td>Vivant Integrated Diesel Corporation</td>
                  </tr>
                  <tr>
                    <td>SI Power Corporation</td>
                  </tr>
                  <tr>
                    <td>Kaltimex Rural Energy Corporation</td>
                  </tr>
                  <tr>
                    <td>PI Energy Inc.</td>
                  </tr>
                </tbody></table>
              <br />
              <small>
                Opening of bids is soon to be scheduled considering finalization of administrative
                arrangements affected by the COVID-19 pandemic.
              </small>
            </h3>
          </div>
        </div>
      </section>
        <hr />
      <section className='contact-section area-padding'>
        <div className='container'>
          <div id='accordionBid2019'>
            <div className='text-center'>
              <button className='btn' type='button' data-toggle='collapse' data-target='#collapseBid2019' data-parent='#accordionBid2019' aria-expanded='false' aria-controls='collapseBid2019'>
                <h1 className='whats-new-pdf-button-header mb-3 text-center'>2019</h1>
              </button>
            </div>
        
          <div id='collapseBid2019' className='collapse hide'> 
            <h3 className='text-heading history-title'>
              INVITATION TO BID<br />
              <small>(2019)</small>
              <br /><br />
              <small>
                Invitation to Bid for the Conduct of Competitive Selection Process (CSP) <br />
                by Marinduque Electric Cooperative, Inc. (MARELCO) <br />
                for its New Power Provider (NPP)
              </small>
            </h3>
            <div className='text-center'>
              <a href='/resources/files/whats_new/invitation_to_bid.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>Download PDF</a>
            </div>
            <br /> <br /> <br />
    
              <h3 className='text-heading history-title'>
                BID BULLETIN<br />
                <small>(2019)</small>
              </h3>
              <div className='text-center'>
                <div className='whats-new-pdf-button-container'>
                  <div className='whats-new-pdf-button-header'>NO. 2019-001</div>
                  <a href='/resources/files/whats_new/Bid Bulletin No. 2019-001.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
                </div>
                <div className='whats-new-pdf-button-container'>
                  <div className='whats-new-pdf-button-header'>NO. 2019-002</div>
                  <a href='/resources/files/whats_new/Bid Bulletin No. 2019-002.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
                </div>
                <div className='whats-new-pdf-button-container'>
                  <div className='whats-new-pdf-button-header'>NO. 2019-003</div>
                  <a href='/resources/files/whats_new/Bid Bulletin No. 2019-003.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
                </div>
                <div className='whats-new-pdf-button-container'>
                  <div className='whats-new-pdf-button-header'>NO. 2019-004</div>
                  <a href='/resources/files/whats_new/Bid Bulletin No. 2019-004.pdf' target='_blank' rel='noopener noreferrer' style={{margin: '0 5px', fontSize: 14}} className='genric-btn info'>DOWNLOAD PDF</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )

}

export default WhatsNew
